export const products = {
	title: "Products",
	header: {
		search: "Search Products",
		edit: "Bulk edit products",
		delete: "Delete products",
		deleteConfirm: "Are you sure you want to delete all selected products?",
		massDelete: "Delete products in bulk",
		add: "Add products",
	},
	error:
		"unable to intentify the corresponding product of {{name}}, download a new template sheet and be careful with the 'identifier' column",
	success: "All products edited successfully",
	errorIn: "Error in ",
	bottomText: "All changes made here will affect all menus",
};
